import { FC } from 'react';
import Link from 'next/link';
import { IBookDetailSeriesData } from '@/interfaces/bookDetail.interface';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { hideImgOnError } from '@/helpers/helpers';
import styles from './BookSeries.module.scss';

interface IBookSeriesProps {
  series: IBookDetailSeriesData[];
}

const BookSeries: FC<IBookSeriesProps> = ({ series }) => {
  return (
    <div className={styles.bookSeries}>
      <div className={styles.bookSeries__title}>Cерия «{series[0].title}»</div>
      <div className={styles.bookSeries__list}>
        {series[0].other_series_books.slice(0, 3).map((item, index) => {
          const bookUrl = `/lib/id${item.alias}`;
          return (
            <div key={`${item.book_id}-${index}`} className={styles.bookSeries__item}>
              <Link prefetch={false} className={styles.bookSeries__imgWrap} href={bookUrl}>
                <img className={styles.bookSeries__img} src={`${DEV_ABSOLUTE_URL}/covers/${item.external_id}.jpg`} alt="img" onError={hideImgOnError} />
              </Link>
              <Link prefetch={false} className={styles.bookSeries__bookTitle} href={bookUrl}>
                {item.title}
              </Link>
            </div>
          );
        })}
      </div>

      <Link prefetch={false} className={styles.bookSeries__btn} href={`/series/${series[0].title_translit}/`}>
        Все книги серии
      </Link>
    </div>
  );
};
export default BookSeries;
